import { writable } from 'svelte/store'

export enum RegistrationStatus {
	NotStarted,
	InProgress,
	Done,
}

export const registrationStatus = writable<RegistrationStatus>(RegistrationStatus.NotStarted)
